import { arrowBack } from 'ionicons/icons'
import { FunctionComponent, ReactNode } from 'react'
import { backFx } from '~/shared/lib/history'
import { IconButton } from '~/shared/ui/Buttons'
import { myPalette } from '../theme'
import { ButtonWrapper, IconWrapper, Title } from './styled'

type ButtonBackProps = {
  onBack?: () => void
  title?: ReactNode | string
  style?: React.CSSProperties
  showIcon?: boolean
}

export const ButtonBack: FunctionComponent<ButtonBackProps> = ({
  onBack,
  title = 'Назад',
  style,
  showIcon = true,
}) => {
  const backFn = onBack || backFx

  return (
    <ButtonWrapper
      onClick={() => backFn()}
      style={style}
      data-testid='back-button'
    >
      {showIcon && (
        <IconWrapper>
          <IconButton
            icon={arrowBack}
            iconProps={{
              style: { color: myPalette.white.main, fontSize: '20px' },
            }}
            style={{ padding: 0 }}
          />
        </IconWrapper>
      )}
      <Title>{title}</Title>
    </ButtonWrapper>
  )
}
